import { z } from "zod";

export const sectionTypeEnum = z.enum(["carousel", "grid", "stacked_carousel"]);

export type SectionType = z.infer<typeof sectionTypeEnum>;
